import styled, { css } from "styled-components";

const ItemLengthCard = ({ label, value, id }) => {
  return (
    <Card $mode={id}>
      <h3>{value}</h3>
      <h2>{label}</h2>
    </Card>
  );
};

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 15px;
  padding: 2rem;

  @media print {
    page-break-inside: avoid;
    padding: 1rem;
  }

  h3 {
    font-size: 18px;
    font-weight: 800;
    color: #fafafa;
  }

  h2 {
    color: #fafafa;
  }

  @media (min-width: 1100px) {
    h3 {
      font-size: 32px;
      font-weight: 800;
      color: #fafafa;
    }
  }
  ${(props) => {
    switch (props.$mode) {
      case "green":
        return css`
          background-color: var(--color-green);
        `;
      case "red":
        return css`
          background-color: var(--color-red);
        `;
      case "basic":
        return css`
          background-color: var(--color-purple);
        `;
      case "yellow":
        return css`
          background-color: var(--color-yellow);
        `;
      default:
        return css`
          background-color: var(--color-green);
        `;
    }
  }}
`;
export default ItemLengthCard;
